import PropTypes from 'prop-types';
import { useEffect, useState, useMemo } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { Select } from 'hb-react/shared/components/formik/components/inputs';

import { getInitialValuesStep3 } from '../../../form/initialValues';

const SelectAddress = ({ currentUser, setSelectedAddress, values }) => {
  const [address, setAddress] = useState('personal');

  const {
    currentNetwork: { user_fields_config: userFieldsConfig },
  } = useDefaultAppContexts();

  useEffect(() => {
    if (address) {
      const {
        receipt: { billing_address_attributes: billingAddressAttributes },
      } = getInitialValuesStep3(
        { currentUser, values },
        { selectedAddress: address },
      );

      setSelectedAddress(billingAddressAttributes);
    }
  }, [address]);

  const selectAddressOptions = useMemo(
    () => ({
      personal:
        userFieldsConfig?.postal_personal_label ||
        I18n.t('web.networks.events.receipt.billing_location.postal_address'),
      work:
        userFieldsConfig?.postal_work_label ||
        I18n.t('web.networks.events.receipt.billing_location.work_address'),
    }),
    [userFieldsConfig],
  );

  return (
    <Select
      name="receipt[address_type]"
      options={selectAddressOptions}
      placeholder={__('Select address')}
      label={__('Choose address')}
      onChange={({ value }) => setAddress(value)}
    />
  );
};

SelectAddress.defaultProps = {
  values: {},
};

SelectAddress.propTypes = {
  currentUser: PropTypes.shape({
    firstname: PropTypes.string.isRequired,
    lastname: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    postal_address: PropTypes.objectOf(
      PropTypes.shape({
        address_1: PropTypes.string,
        address_2: PropTypes.string,
        address_3: PropTypes.string,
        country: PropTypes.string,
        city: PropTypes.string,
        postal_code: PropTypes.string,
        state: PropTypes.string,
      }),
    ),
  }).isRequired,
  setSelectedAddress: PropTypes.func.isRequired,
};

export default SelectAddress;
